var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1627",
    "data-name": "Group 1627",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.277,
    height: 66,
    viewBox: "0 0 59.277 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 59.277,
    height: 66,
    fill: "#5763f3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M170.357,122.377l-4.449,7.736h-7.2l8.2-11.554L159.268,107.2h6.972l4.316,7.636L175.2,107.2h6.872l-8,11.255,8.068,11.653h-6.972Z",
    transform: "translate(-140 -94.57)",
    fill: "#5763f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M59.181,57.2,51.29,34.094A23.834,23.834,0,0,0,47.1,7.857h.123a23.544,23.544,0,0,0-35.114,0h.123A23.837,23.837,0,0,0,7.81,33.577L.1,57.043A3.306,3.306,0,0,0,1.353,60.5a3.309,3.309,0,0,0,3.771,0l7.229-5.186A1.935,1.935,0,0,1,13.924,55a1.9,1.9,0,0,1,1.1,1.1l2.986,7.7A3.206,3.206,0,0,0,21.153,66h.157a3.548,3.548,0,0,0,3.143-2.514L29.044,47.9q.31.008.622.008c.176,0,.351,0,.526-.007l4.632,15.581A3.5,3.5,0,0,0,37.967,66h.157a3.348,3.348,0,0,0,3.143-2.2l2.986-7.7a1.552,1.552,0,0,1,1.1-1.1,1.827,1.827,0,0,1,1.571.314l7.229,5.343A3.247,3.247,0,0,0,59.181,57.2M21.467,62.7c-.157,0-.157.157-.314.157a.549.549,0,0,1-.314-.157L17.853,55a4.6,4.6,0,0,0-3.143-2.986,4.355,4.355,0,0,0-1.414-.157,5.07,5.07,0,0,0-2.829.943L3.238,57.986l6.412-21.9a23.533,23.533,0,0,0,16.512,10.8Zm8.171-18.591A20.469,20.469,0,1,1,50.107,23.64,20.469,20.469,0,0,1,29.638,44.109M48.81,52.8a4.638,4.638,0,0,0-4.243-.786A5.344,5.344,0,0,0,41.424,55l-2.986,7.7s0,.157-.314.157-.314-.157-.314-.157l-4.7-15.811A23.534,23.534,0,0,0,49.622,36.1l.288.991c.009.028.021.054.032.081l6.1,20.819Z",
    transform: "translate(0)",
    fill: "#5763f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft2);
export default __webpack_public_path__ + "static/media/left_2.7b2df641f33c908227b64973e4d219df.svg";
export { ForwardRef as ReactComponent };